import Marionette from 'backbone.marionette';
import navlinkTmpl from '../templates/navlink.tpl';
export default Marionette.ItemView.extend({
  template: navlinkTmpl,
  tagName: "li",
  events: {
    "click a": "navigate"
  },
  navigate: function (e) {
    e.preventDefault();
    this.trigger("navigate", this.model);
    // $('#top-nav').collapse("hide");
  }
});